import React from "react";
import { Navigate } from "react-router-dom";

const LoginControlListComponent = React.lazy(
  () => import("../../../../../components/login-control/components/list/page"),
);
const LogMailsListComponent = React.lazy(
  () => import("../../../../../components/logs/components/mails/page"),
);
const LogPhonesListComponent = React.lazy(
  () => import("../../../../../components/logs/components/phones/page"),
);

export const auditoriaRoutes = [
  {
    path: "access",
    element: <LoginControlListComponent />,
  },
  {
    path: "whatsapps",
    element: <LogPhonesListComponent />,
  },
  {
    path: "mails",
    element: <LogMailsListComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/administration/auditoria/access" />,
  },
];
